





















































import { computed, defineComponent, getCurrentInstance, PropType, ref, Ref } from 'vue';
import Icon from '../Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import Multiselect from '@vueform/multiselect';
import { MultiselectGroup, MultiselectOption } from '../../types';

export default defineComponent({
  name: 'AulaMultiselect',
  components: { Icon },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: Array as PropType<number[] | string[]>, default: () => [] },
    mode: { type: String as PropType<'tags' | 'single' | 'multiple'>, default: 'tags' },
    options: { type: Array as PropType<MultiselectGroup<MultiselectOption>[]>, required: true },
    placeholder: { type: String, default: '' },
    noResultsText: { type: String, default: '' },
    groupSelect: { type: Boolean, default: false },
    canClear: { type: Boolean, default: true },
    groups: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: false },
    closeOnDeselect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['change', 'select', 'deselect'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const multiselectRef: Ref<InstanceType<typeof Multiselect> | null> = ref(null);

    const isMultiselect = computed(() => props.mode === 'tags' || props.mode === 'multiple');

    const handleFilterClear = async () => {
      const warning = proxy.$createElement('p', { domProps: { innerHTML: proxy.$t('warning.clear_all') } });
      const isConfirmed = await proxy.$confirmAction([warning]);
      if (isConfirmed) {
        multiselectRef.value?.clear();
      }
    };

    const emitChange = value => {
      emit('change', value);
    };

    const emitSelect = (value, option) => {
      emit('select', value, option);
    };

    const emitDeselect = (value, option) => {
      emit('deselect', value, option);
    };

    return {
      multiselectRef,
      isMultiselect,
      handleFilterClear,
      emitChange,
      emitSelect,
      emitDeselect,
      iconClassEnum,
    };
  },
});
